import { classes, react } from "../../../omnia"

interface Props {
    title: string
    className: string
}

export function Header({ children, title, className: cssClass }: React.PropsWithChildren<Props>) {

    const [expanded, setExpanded] = React.useState(true)

    return <div className={classes("analysis", cssClass)}>

        <h3 onClick={() => setExpanded(!expanded)}>
            {title}
            <button type="button" className="btn btn-icon transparent">
                <i className={classes(["fas", expanded ? "fa-angle-up" : "fa-angle-down"])}></i>
            </button>
        </h3>

        {
            expanded && children
        }

    </div>

}
